/** Hinweis: unabhängiger Reparaturservice, keine Apple-Autorisierung. */
export const INDEPENDENT_REPAIR_APPLE_DISCLAIMER_DE =
  'Wir sind ein unabhängiger Reparaturservice und kein autorisierter Apple Partner.';
